
import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARD from '../apiUrls';

const mutationAddSimCardsFromOrderId = (onSuccess, onError) => {
    return {
        mutationFn: ({ orderId, organizationId }) => {
            return client.post(SIM_CARD.ADD_SIM_CARDS_FROM_ORDER_ID.url, { orderId, client: organizationId });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddSimCardsFromOrderId;